import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { validateEmail, validateFullName } from '../../../formValidators';
import PasswordInput from '../../PasswordInput';
import StyledTextField from '../../common/StyledTextField';
import SocialLoginForm from '../SocialLoginForm';
var renderAgreementLinks = function renderAgreementLinks(signInUrl) {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "terms-and-privacy-label body-text-3 normal-weight"
  }, "By signing up, you agree to", /*#__PURE__*/React.createElement("a", {
    href: "/terms-of-use",
    className: "terms-of-use"
  }, " Clora's Terms of Use"), ' ', "and", /*#__PURE__*/React.createElement("a", {
    href: "/privacy-policy",
    className: "privacy-policy"
  }, " Privacy Policy"), "."), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight text-center mt-3"
  }, "Already have a Clora account?\xA0", /*#__PURE__*/React.createElement("a", {
    href: signInUrl,
    className: " p-0"
  }, "Log in")));
};
var ConsultantForm = /*#__PURE__*/function (_Component) {
  function ConsultantForm(props) {
    var _this;
    _classCallCheck(this, ConsultantForm);
    _this = _callSuper(this, ConsultantForm, [props]);
    _this.state = {
      email: props.invitedEmail || '',
      password: '',
      userName: props.userName || '',
      errors: {},
      submitted: false,
      showLocalRegistrationFields: false
    };
    _this.handleUpdateField = _this.handleUpdateField.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.toggleLocalRegistrationFields = _this.toggleLocalRegistrationFields.bind(_this);
    return _this;
  }
  _inherits(ConsultantForm, _Component);
  return _createClass(ConsultantForm, [{
    key: "handleValidate",
    value: function handleValidate() {
      var _this$state = this.state,
        email = _this$state.email,
        userName = _this$state.userName,
        password = _this$state.password,
        errors = _this$state.errors;
      var fullNameValidation = validateFullName(userName);
      var emailValidation = validateEmail(email);
      this.setState({
        errors: _objectSpread(_objectSpread({}, errors), {}, {
          email: emailValidation.error,
          userName: fullNameValidation.error,
          password: password.length ? null : 'Please fill out this field.'
        })
      });
      return !emailValidation.error && fullNameValidation.isValid && password.length;
    }
  }, {
    key: "handleUpdateField",
    value: function handleUpdateField(field) {
      var _this2 = this;
      return function (e) {
        return _this2.setState(_defineProperty({}, field, e.target.value));
      };
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      if (this.handleValidate()) {
        this.setState({
          submitted: true
        });
      } else {
        e.preventDefault();
      }
    }
  }, {
    key: "toggleLocalRegistrationFields",
    value: function toggleLocalRegistrationFields() {
      this.setState(function (prevState) {
        return {
          showLocalRegistrationFields: !prevState.showLocalRegistrationFields
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        invitedEmail = _this$props.invitedEmail,
        signUpPath = _this$props.signUpPath,
        children = _this$props.children,
        referralToken = _this$props.referralToken,
        projectResourceId = _this$props.projectResourceId,
        sourced = _this$props.sourced,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        postOnboardUrl = _this$props.postOnboardUrl,
        signInUrl = _this$props.signInUrl;
      var _this$state2 = this.state,
        email = _this$state2.email,
        errors = _this$state2.errors,
        submitted = _this$state2.submitted,
        userName = _this$state2.userName,
        showLocalRegistrationFields = _this$state2.showLocalRegistrationFields;
      return /*#__PURE__*/React.createElement("form", {
        id: "create_consultant",
        action: signUpPath || '/registration/consultants',
        acceptCharset: "UTF-8",
        method: "post",
        "data-turbo": "false",
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/React.createElement(StyledTextField, {
        id: "email",
        className: "form-control fs-hide validate",
        name: "user[email]",
        label: "Email",
        type: "email",
        value: email,
        error: !!errors.email,
        helperText: errors.email,
        onChange: this.handleUpdateField('email'),
        required: true
      }), showLocalRegistrationFields ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyledTextField, {
        id: "full_name",
        className: "form-control fs-hide",
        value: userName,
        error: !!errors.userName,
        helperText: errors.userName,
        onChange: this.handleUpdateField('userName'),
        name: "user[full_name]",
        label: "Full Name",
        type: "text",
        autoFocus: true,
        required: true
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "authenticity_token",
        value: csrfToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "invited_email",
        value: invitedEmail
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "referral_token",
        value: referralToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "project_resource_id",
        value: projectResourceId
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[sourced]",
        value: sourced
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "post_onboard_url",
        value: postOnboardUrl
      }), children, /*#__PURE__*/React.createElement(PasswordInput, {
        errors: errors.password,
        title: "Password",
        handleChange: this.handleUpdateField('password')
      }), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        name: "commit",
        id: "consultant-sign-up",
        className: "btn btn-primary bigger-button",
        disabled: submitted,
        tabIndex: "0"
      }, "Sign Up as a Consultant"))) : /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.toggleLocalRegistrationFields,
        className: "btn btn-primary bigger-button full-width mb-3"
      }, "Continue"), (googleOmniauthUrl || msOmniauthUrl) && /*#__PURE__*/React.createElement(SocialLoginForm, {
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        state: "register_consultant"
      })), renderAgreementLinks(signInUrl));
    }
  }]);
}(Component);
ConsultantForm.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  signUpPath: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  referralToken: PropTypes.string,
  userName: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  projectResourceId: PropTypes.string,
  sourced: PropTypes.string,
  postOnboardUrl: PropTypes.string
};
ConsultantForm.defaultProps = {
  invitedEmail: null,
  signUpPath: null,
  children: null,
  referralToken: null,
  userName: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  projectResourceId: null,
  sourced: null,
  postOnboardUrl: null
};
export default ConsultantForm;